import React from 'react'
import PropTypes from 'prop-types'

const Favicon = ({publicPath, appName, safariPinnedTabColor, msapplicationTileColor, themeColor}) => {
  return (
    <>
      <link rel="manifest" href={`${publicPath}/manifest.json`} />
      <link rel="shortcut icon" href={`${publicPath}/favicon.ico`} />
      <link rel="apple-touch-icon" sizes="180x180" href={`${publicPath}/apple-touch-icon.png`} />
      <link rel="icon" type="image/png" sizes="32x32" href={`${publicPath}/favicon-32x32.png`} />
      <link rel="icon" type="image/png" sizes="16x16" href={`${publicPath}/favicon-16x16.png`} />
      <link rel="manifest" href={`${publicPath}/site.webmanifest`} />
      <link rel="mask-icon" href={`${publicPath}/safari-pinned-tab.svg`} color={safariPinnedTabColor} />
      <meta name="apple-mobile-web-app-title" content="Snippit" />
      <meta name="application-name" content={appName} />
      <meta name="msapplication-TileColor" content={msapplicationTileColor} />
      <meta name="theme-color" content={themeColor} />
    </>
  )
}

Favicon.propTypes = {
  publicPath: PropTypes.string,
  appName: PropTypes.string.isRequired,
  safariPinnedTabColor: PropTypes.string.isRequired, // https://developer.apple.com/library/archive/documentation/AppleApplications/Reference/SafariWebContent/pinnedTabs/pinnedTabs.html
  msapplicationTileColor: PropTypes.string.isRequired,
  themeColor: PropTypes.string.isRequired // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/meta/name/theme-color
}

Favicon.defaultProps = {
  publicPath: ''
}

export {Favicon}
